import React, { useState } from 'react'

import {
    Loading, Modal, Container, InputText, InputSearch, DataGrid, FilterBar, Paginate, InputSelect
} from 'src/components'

import PropTypes from 'prop-types';
import NumberFormat from "react-number-format";
import PrintStatusPedPDV from './components/PrintStatusPedPDV'
import moment from 'moment'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import {
    faAddressBook,
    faWindowClose,
    faSave,
} from '@fortawesome/free-regular-svg-icons'

import {
    faBook, 
    faDesktop, 
    faListUl,
    faShareSquare,
} from '@fortawesome/free-solid-svg-icons'

import dayjs from 'dayjs'
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { useSelector, useDispatch } from 'react-redux'
import Typography from '@material-ui/core/Typography';
import { Icon, IconButton, Tooltip, Grid, Paper, Tabs, Tab, Box, Badge, Button, Divider } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useStyles from './styles'
import _ from 'lodash'
import {
    Delete as DeleteIcon,
    DeleteForever as DeleteForeverIcon,
    AccountBalance as AccountBalanceIcon,
    Edit as EditIcon,
    Add as AddIcon,
    Remove as RemoveIcon,
    PersonAdd,
    AddShoppingCart as AddCart,
    AddBox,
    TransferWithinAStation as Transfer,
    MoneyOff as DiscountItem,
    Print,
} from '@material-ui/icons';

import DialogAlert from './components/DialogAlert'
import BudgetCardapio from './components/budgetCardapio'
import NBudgetCardapio from './components/nbudgetCardapio'

import * as types from '../../store/types/comanda'
import {
    getMesas,
    getCategorias,
    setNewMesa,
    detalhesComanda,
    getMesaSel,
    loadCardapio,
    searchCpf,
    insertCli,
    insertItem,
    filterListaItems,
    getClis,
    loadCliItems,
    transferItems,
    getCardapioPerCat,
    createPedidoPdv,
    getListPedPDV,
    getPedidoPdvById,
    deletePedidoPDV,
} from '../../store/actions/comanda'
import { useEffect } from 'react';
import { carregarCategorias } from '../../store/actions/categorias';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const Comanda = props => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const {
        loading,
        mesas,
        clientes,
        mesa,
        resumo_mesa,
        itemsLista,
        mesaSel,
        clientes_mesa_lista,
        cliente_mesa_selecionado,
        cardapio,
        prods_page,
        prods_perpage,
        prods_total,
        cliSel,
        dialog,
        listaClientes,
        clienteComandaSel,
        listaCategorias,
        cardapio_pdv,
        cliPDV,
        cliPDVCpf,
        listaPedidospdv,
        resumoPedPDV,
        pedPDVSelect,
        pdv_pedido_selecionado,
        pdv_pedido_editar,
    } = useSelector(state => state.comanda)

    const [tipoConsulta, setTipoConsulta] = useState(0)
    const [catPDV, setCatPDV] = useState(0)
    const [itemSelStats, setItemSelStats] = useState([])
    const [pedidoPDV, setPedidoPDV] = useState([])
    const [listaItemsToTransfer, setListaItemsToTransfer] = useState([])
    const [itemToPay, setItemToPay] = useState({ total_qtd: 0, valor: 0, gorjeta: 0, total_com_servico: 0, cashback: 0 })
    const [itemPedidoPDV, setItemPedidoPDV] = useState({ total_qtd: 0, valor: 0, gorjeta: 0, total_com_servico: 0, cashback: 0 })
    const [itemPedidoPDV_selecionado, setItemPedidoPDV_selecionado] = useState({ total_qtd: 0, valor: 0, gorjeta: 0, total_com_servico: 0, cashback: 0 })
    const [itemPedidoPDV_editar, setItemPedidoPDV_editar] = useState({ total_qtd: 0, valor: 0, gorjeta: 0, total_com_servico: 0, cashback: 0 })
    const [setButtons, setSetButtons] = useState([
        { id: '1', danger: false, icon: <AddBox />, title: "Adicionar Mesa", onClick: () => { setModals({ ...modals, mesa_add: true }) } },
        { id: '2', disabled: true, danger: false, icon: <PersonAdd />, title: "Adicionar Cliente", onClick: () => { setModals({ ...modals, cliente_add: true }) } },
        { id: '3', disabled: true, danger: false, icon: <AddCart />, title: "Adicionar Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
        { id: '4', disabled: true, danger: false, icon: <Transfer />, title: "Transferir Item", onClick: () => { setModals({ ...modals, transferProdTo: true }) } },
        { id: '5', disabled: true, danger: false, icon: <DeleteIcon />, title: "Remover Item", onClick: () => excluirItemComanda() },
        //{ id: '6', disabled: true, danger: false, icon: <DiscountItem />, title: "Desconto Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
    ])
    const [clienteToTransferSelecionado, setClienteToTransferSelecionado] = useState(0)
    const [modals, setModals] = useState({
        mesa_add: false, 
        item_add: false, 
        prodSearch: false, 
        cliente_add: false, 
        cliSearch: false, 
        transferProdTo: false,
        atrib_cli_pdv: false,
        editar_pedido: false,
    })
    const [prodSel, setProSel] = useState({ titulo: '', id: 0, preco: 0, ref: '' })
    const [pesqFiltro, setPesqFiltro] = useState({ nome: '' })

    const setMesaToList = (mesa_id) => {
        dispatch([
            getMesaSel({ mesa_id: mesa_id })
        ])
    }

    const chosenButtons = (pack_id) => {
        if (pack_id == 0) {
            setSetButtons([
                { id: '1', danger: false, icon: <AddBox />, title: "Adicionar Mesa", onClick: () => { setModals({ ...modals, mesa_add: true }) } },
                { id: '2', disabled: true, danger: false, icon: <PersonAdd />, title: "Adicionar Cliente", onClick: () => { setModals({ ...modals, cliente_add: true }) } },
                { id: '3', disabled: true, danger: false, icon: <AddCart />, title: "Adicionar Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
                { id: '4', disabled: true, danger: false, icon: <Transfer />, title: "Transferir Item", onClick: () => { setModals({ ...modals, transferProdTo: true }) } },
                { id: '5', disabled: true, danger: false, icon: <DeleteIcon />, title: "Remover Item", onClick: () => excluirItemComanda() },
                //{ id: '6', disabled: true, danger: false, icon: <DiscountItem />, title: "Desconto Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
            ])
        } else if (pack_id == 1) {
            setSetButtons([
                { id: '11', disabled: false, danger: false, icon: <AddCart />, title: "Adicionar Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
                { id: '12', disabled: false, danger: false, icon: <Transfer />, title: "Transferir Item", onClick: () => { setModals({ ...modals, transferProdTo: true }) } },
                { id: '13', disabled: false, danger: false, icon: <DeleteIcon />, title: "Remover Item", onClick: () => excluirItemComanda() },
                //{ id: '14', disabled: false, danger: false, icon: <DiscountItem />, title: "Desconto Item", onClick: () => { setModals({ ...modals, item_add: true }) } },
            ])
        } else if (pack_id == 2) {
            setSetButtons([
                { id: '21', disabled:true, danger: false, icon: <AddIcon />, title: "Gravar Pedido", onClick: () => { makePedPDV(); } },
                //{ id: '22', disabled:true, danger: false, icon: <EditIcon />, title: "Editar Pedido", onClick: () => { setModals({ ...modals, editar_pedido: true }) } },
                //{ id: '23', danger: false, icon: <AddIcon />, title: "Adicionar 9", onClick: () => { setModals({ ...modals, mesa_add: true }) } }
            ])
        } else if (pack_id == 3) {
            setSetButtons([
                { id: '31', disabled:true, danger: false, icon: <DeleteForeverIcon />,  title: "Cancelar Pedido",  onClick: () => { cleanAfterCancelPedPDV(pdv_pedido_selecionado.id) } },
                { id: '32', disabled:true, danger: false, icon: <AccountBalanceIcon />, title: "Receber Pedido",   onClick: () => { alert(`recebendo pedido ${pdv_pedido_selecionado.id}`) } },
                //{ id: '23', danger: false, icon: <AddIcon />, title: "Adicionar 9", onClick: () => { setModals({ ...modals, mesa_add: true }) } }
            ])
        }
    }

    function cleanAfterCancelPedPDV( id ){
        let att_payload = {
            id: '',
            referencia: '',
            cpf_nota: '',
            items: []
        }

        dispatch([
            {type: types.MESAS_LOADING, payload: true},
            deletePedidoPDV(id),
            {type: types.PEDIDO_PDV_EFETIVADO , payload: att_payload},
            {type: types.PEDIDO_PDV_EDIT , payload: att_payload},
        ])
    }

    function generateCliPDV(length=4) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        

        return dispatch([
            {type: types.CLI_PDV, payload: result}
        ])
     }

     function makePedPDV() {
         let items = pedidoPDV
         let att_payload = {
            id: '',
            referencia: '',
            cpf_nota: '',
            items: []
        }
        dispatch([
            {type: types.MESAS_LOADING, payload: true},
            createPedidoPdv(items),
            {type: types.PEDIDO_PDV_EFETIVADO , payload: att_payload},
            {type: types.PEDIDO_PDV_EDIT , payload: att_payload},
        ])
     }

     function setCliPDVCpf(dado) {
         dispatch([
             {type: types.CLI_PDV_CPF, payload: dado}
         ])
     }

    function clearMesaECli() {
        dispatch([
            { type: types.CLIENTE_MESA_SELECIONADO, payload: { id: 0, nome: '' } },
            { type: types.MESA_SELECTED, payload: {} },
            { type: types.ITEMS_LISTA, payload: [] },
        ])
    }

    function loadCardapioPDV() {
        dispatch([
            getCardapioPerCat(catPDV)
        ])
    }

    function inserirProduto() {
        if (mesaSel.id > 0) {
            dispatch([
                insertItem(mesaSel.id, prodSel.id, cliente_mesa_selecionado)
            ])
        } else {
            dispatch([
                { type: types.SET_DIALOG, payload: { show: true, title: 'Ops', description: 'Selecione uma mesa antes de inserir um produto!' } }
            ])
        }
    }

    function listItemsUsuario(cliente_id) {
        dispatch([
            loadCliItems({ cliente_id, })
        ])
    }

    function transferirProdutos() {
        if (clienteToTransferSelecionado > 0 && listaItemsToTransfer.length > 0) {
            dispatch([
                transferItems(clienteToTransferSelecionado, listaItemsToTransfer)
            ])
        }
    }

    function inserirCliMesa() {
        if (mesaSel.id > 0) {
            dispatch([
                insertCli(mesaSel.id, cliSel.id)
            ]);
            carregarMesas();
            carregarClientes();
            setMesaToList(mesaSel.id);
        } else {
            dispatch([
                { type: types.SET_DIALOG, payload: { show: true, title: 'Ops', description: 'Selecione uma mesa antes de inserir um cliente!' } }
            ])
        }
    }

    function handleCloseDialog() {
        dispatch([{ type: types.SET_DIALOG, payload: { ...dialog, show: false } }])
    }

    function consultaCPF() {
        searchCpf(cliSel.cpf).then(
            resp => {
                dispatch([
                    { type: types.SET_PESQ_CLI, payload: { ...cliSel, nome: resp.nome, id: resp.id } }
                ])
            },
            err => console.log(err)
        )
    }

    function setMesaFilterItems(cli_id) {
        let cli_aidi = (cli_id == "") ? 0 : parseInt(cli_id);
        var pesq = { mesa_id: mesaSel.id, cliente_id: cli_aidi }
        dispatch([
            { type: types.CLIENTE_MESA_SELECIONADO, payload: cli_id },
            filterListaItems(pesq)
        ]);
    }

    function handleChangePage(newPage) {
        dispatch([
            { type: types.SET_PROD_PAGE, payload: (newPage + 1) },
            loadCardapio({ ...pesqFiltro, per_page: prods_perpage, page: (newPage + 1) })
        ])
    }

    function handleChangeRowsPerPage(event) {
        let rows = event.target.value
        dispatch([
            { type: types.SET_PROD_PERPAGE, payload: rows },
            loadCardapio({ ...pesqFiltro, per_page: rows, page: 1 })
        ])
    }


    const excluirItemComanda = () => {
        let itemExcluir = itemSelStats
        let novosItems = resumo_mesa.items?.filter((item) => !itemExcluir.includes(item))

        let arq = {
            dados: { ...resumo_mesa.dados },
            items: novosItems
        }
        // set_resumo_mesa(arq)
        // setItemToPay({total_qtd: 0, valor: 0, gorjeta: 0, total_com_servico: 0 })
    }

    const selItemToPay = (row_select) => {
        let total = 0
        let valor = 0
        let gorjeta = 0
        let cashback = 0
        let total_com_servico = 0
        

        if (row_select.length > 0) {
            row_select.filter((item) => {
                if (item.pagamento_id == null) {
                    total += 1
                    valor += item.preco
                    gorjeta += item.gorjeta
                }
            })
        }

        total_com_servico = valor + gorjeta

        setItemSelStats(row_select)
        setItemToPay({ total_qtd: total, valor: valor.toFixed(2), gorjeta: gorjeta.toFixed(2), total_com_servico: total_com_servico.toFixed(2) })

    }

    const reduceItemPDV = (dados) => {

        const pedidopdv = pedidoPDV
        let total = 0
        let valor = 0
        let gorjeta = 0
        let cashback = 0
        let total_com_servico = 0
        let newPedidoPdv = []

        if(pedidopdv.find( pedidopdv => pedidopdv.produto_id == dados.produto_id)){
            pedidopdv.forEach( row => {
                if(row.produto_id == dados.produto_id){
                    let rCb = ((row.percent_cashback/100)*row.valor_atual)
                    row.qtd_pedido -= 1
                    row.cashback -= rCb
                    row.valor_total -= dados.valor_atual
                }
            })
        }


        if (pedidopdv.length > 0) {
            pedidopdv.map( (row, index) => {
                    let comiss = ((row.valor_total * 10)/100)
                    
                    total += row.qtd_pedido
                    valor += row.valor_total
                    gorjeta += comiss
                    cashback += row.cashback
                    total_com_servico += (comiss + row.valor_total)

            })
        }

        total_com_servico = valor + gorjeta

        pedidopdv.forEach( row => {
            if(row.qtd_pedido > 0){
                newPedidoPdv.push(row)
            }
        })
        console.log(newPedidoPdv)

        setPedidoPDV(newPedidoPdv)
        setItemPedidoPDV({ total_qtd: total, valor: valor.toFixed(2), gorjeta: gorjeta.toFixed(2), cashback: cashback.toFixed(2), total_com_servico: total_com_servico.toFixed(2) })

    }
    
    const selItemPedidoPDV = (dados) => {
        const pedidopdv = pedidoPDV
        let total = 0
        let valor = 0
        let gorjeta = 0
        let cashback = 0
        let total_com_servico = 0

        if(pedidopdv.find( pedidopdv => pedidopdv.produto_id == dados.produto_id)){

            pedidopdv.forEach( row => {
                if(row.produto_id == dados.produto_id){

                    let nCs = ((dados.percent_cashback/100)*dados.valor_atual)
                   
                    row.qtd_pedido += 1
                    row.valor_total += dados.valor_atual
                    row.cashback += nCs
                    
                }
            })
        }else{
            
            pedidopdv.push({
                            titulo: dados.titulo, 
                            produto_id: dados.produto_id,
                            valor_atual: dados.valor_atual, 
                            qtd_pedido: 1, 
                            cashback: ((dados.percent_cashback/100)*dados.valor_atual),
                            percent_cashback: dados.percent_cashback,
                            valor_total: (dados.valor_atual*1)
                        })
        }


        if (pedidopdv.length > 0) {
            pedidopdv.map( (row, index) => {
                let comiss = ((row.valor_total * 10)/100)

                total += row.qtd_pedido
                valor += row.valor_total
                cashback += row.cashback
                gorjeta += comiss
                
                total_com_servico += (comiss + row.valor_total)

            })
        }

        total_com_servico = valor + gorjeta

        setPedidoPDV(pedidopdv)
        setItemPedidoPDV({ total_qtd: total, valor: valor.toFixed(2), gorjeta: gorjeta.toFixed(2), total_com_servico: total_com_servico.toFixed(2), cashback: cashback.toFixed(2) })

    }

    const calcResultsPedidoPDVSelecionado = () => {
        let items = pdv_pedido_selecionado.items || [];
        
        let c = {
            total_qtd         : 0,
            valor             : 0,
            gorjeta           : 0,
            cashback          : 0,
            total_com_servico : 0,
        }

        if(items.length > 0){
            items.forEach( item => {
                let vl_tt = (item.valor_atual*item.qtd_pedido)
                let vl_cb = ((vl_tt*item.percent_cashback)/100)
                let comiss = ((vl_tt*10)/100)

                c.total_qtd += parseFloat(item.qtd_pedido)
                c.valor += parseFloat(vl_tt)
                c.gorjeta += parseFloat(comiss)
                c.cashback += parseFloat(vl_cb)
                c.total_com_servico += parseFloat((comiss + vl_tt))
            })
        }
        setItemPedidoPDV_selecionado(c)
    }

    const setItemToTransfer = (row_select) => {
        let ids = row_select.map((item) => { return item.item_comanda_id })

        setListaItemsToTransfer(ids)
    }

    const carregarCategorias = () => {
        dispatch([
            getCategorias(),
        ])
    }

    const carregarMesas = () => {
        dispatch([
            getMesas(),
        ])
    }

    const carregarClientes = () => {
        dispatch([
            getClis()
        ])
    }

    const carregarPedidosPDV = () => {
        dispatch([
            getListPedPDV()
        ])
    }

    const carregarProds = (filtro = "") => {
        dispatch([
            loadCardapio({ ...pesqFiltro, page: 1, per_page: prods_perpage }),
        ])
    }

    function renderValor(rowData) {
        return rowData.tipo !== 'R' ?
            <NumberFormat value={rowData.preco || 0} decimalSeparator={","} thousandSeparator={'.'} fixedDecimalScale={true} decimalScale={2} prefix={`R$ `} style={{ color: '#373737' }} displayType="text" /> :
            <NumberFormat value={(rowData.preco * (-1)) || 0} decimalSeparator={","} thousandSeparator={'.'} fixedDecimalScale={true} decimalScale={2} prefix={`R$ `} style={{ color: '#cc0000' }} displayType="text" />;
    }

    const inserirMesa = () => {
        dispatch([{ type: types.MESAS_LOADING, payload: true }])
        setNewMesa({ ...mesa })
        cleanFormMesa()
        setModals({ mesa_add: false })
        carregarMesas()
    }

    useEffect(() => { loadCardapioPDV() }, [catPDV])
    useEffect(() => { carregarCategorias() }, [])
    useEffect(() => { carregarMesas() }, [tipoConsulta])
    useEffect(() => { carregarProds() }, [])
    useEffect(() => {
        calcResultsPedidoPDVSelecionado()
    }, [pdv_pedido_selecionado])
    useEffect(() => { carregarClientes() }, [tipoConsulta])
    useEffect(() => {
        if (mesaSel.id > 0) {

            let newButtons = setButtons.map((item) => {
                let obj = {}
                let ad_obj = { disabled: false }
                if (item.id >= 2 && item.id <= 10) {
                    return obj = { ...item, ...ad_obj }
                } else {
                    return obj = { ...item }
                }
            })
            setSetButtons([...newButtons])
        }
    }, [mesaSel])
    useEffect(() => {
        if(tipoConsulta == 2){

            if(cliPDV.length > 2){
                let newButtons = setButtons.map( item => {
                    let obj = {}
                    let ad_obj = { disabled: false }
                    if(item.id == 21){
                        return obj = { ...item, ...ad_obj}
                    }else{
                        return obj = { ... item}
                    }
                }) 
                setSetButtons([...newButtons])
            }else{
                setSetButtons([{ id: '21', disabled:true, danger: false, icon: <AddIcon />, title: "Gravar Pedido", onClick: () => { makePedPDV() } }])
            }
        }
    },[cliPDV])

    useEffect( () => {
        carregarPedidosPDV()
    }, [tipoConsulta])
    useEffect( () => {
        
        if(tipoConsulta == 3){
            if(pdv_pedido_selecionado.id > 0){
                setSetButtons([
                    { id: '31', disabled:false, danger: false, icon: <DeleteForeverIcon />,  title: "Cancelar Pedido",  onClick: () => { dispatch([{type: types.MESAS_LOADING, payload: true},deletePedidoPDV(pdv_pedido_selecionado.id)])} },
                    { id: '32', disabled:false, danger: false, icon: <AccountBalanceIcon />, title: "Receber Pedido",   onClick: () => { alert(`recebendo pedido ${pdv_pedido_selecionado.id}`) } },
                ])
            }else{
                setSetButtons([
                    { id: '31', disabled:true, danger: false, icon: <DeleteForeverIcon />,  title: "Cancelar Pedido",  onClick: () => { cleanAfterCancelPedPDV(pdv_pedido_selecionado.id) } },
                    { id: '32', disabled:true, danger: false, icon: <AccountBalanceIcon />, title: "Receber Pedido",   onClick: () => { alert(`recebendo pedido ${pdv_pedido_selecionado.id}`) } },
                ])
            }
        }
        
    },[pdv_pedido_selecionado])


    const changed = e => dispatch({ type: types.SET_MESA, payload: { ...mesa, ...e } })


    function cleanFormMesa() {
        return dispatch({ type: types.SET_MESA, payload: { identificacao: '', localizacao: '' } })
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;
        return (<> {value === index && <Box>{children}</Box>}</>);
    }

    function PrintCatTabs(props) {
        
        const {dados, valueTabs, variantTabs, indicatorColorTabs, textColorTabs, onChangeTabs} = props
        return (
            <>
            <Tabs 
                value={valueTabs} 
                variant={variantTabs || 'secondary'} 
                indicatorColor={indicatorColorTabs || 'secondary'}
                textColor={textColorTabs || "secondary"}
                onChange={(e, newValue) => { onChangeTabs(newValue); loadCardapioPDV()}}
            >
                <Tab 
                    label="Todas"
                    value={0}
                    wrapped
                    />
                                            
            {dados.map( (row, index) => {
                return (<Tab label={row.label} value={row.value} key={index} />)
            })}


            </Tabs>
            <TabPanel dados={[]}>
                <NBudgetCardapio dados={cardapio_pdv} onClickFunction={selItemPedidoPDV} />
            </TabPanel>
            </>
        )
    }


    function Mesas(props) {
        const list = props.list || []
        let bcg;
        return list.map((ls, i) => {
            bcg = ls.status === 'D' ? classes.gray : ls.status === 'O' ? classes.green : ls.status === 'R' ? classes.yellow : ls.status === 'C' ? classes.red : classes.grey;
            return (
                <div key={i}>
                    <div style={{ marginTop: 30 }}>
                        <Badge badgeContent={ls.clientes} color="primary" >
                            <Button className={[classes.badge, classes.mesa, bcg]} onClick={() => { setMesaToList(ls.id) }}>{ls.identificacao}</Button>
                        </Badge>
                    </div>
                </div>
            )
        })
    }

    function ListaClientes(props) {
        const list = props.list || []

        return (
            <div>
                <PerfectScrollbar>
                    <DataGrid
                        id="grid_entidades"
                        columns={[
                            {
                                title: 'Nome',
                                field: 'nome',
                            },
                            {
                                title: 'CPF',
                                field: 'cpf',
                            },
                            {
                                title: 'Qtd',
                                field: 'qtd'
                            },
                            {
                                title: 'Total',
                                field: 'total',
                                render: (rowData) => <NumberFormat value={rowData.total || 0} decimalSeparator={","} thousandSeparator={'.'} fixedDecimalScale={true} decimalScale={2} prefix={`R$ `} style={{ color: '#373737' }} displayType="text" />
                            }
                        ]}
                        data={list}
                        onRowClick={(event, rowData) => {
                            dispatch([
                                { type: types.SET_CLI_COMANDA_SEL, payload: { id: rowData.id, cpf: rowData.cpf, nome: rowData.nome } },
                                { type: types.CLIENTES_MESA_LISTA, payload: [{ value: rowData.id, label: rowData.nome }] },
                                { type: types.CLIENTE_MESA_SELECIONADO, payload: rowData.id }
                            ]);
                            listItemsUsuario(rowData.id);
                        }}
                        options={{
                            maxBodyHeight: 1000,
                            minBodyHeight: 400,
                            rowStyle: rowData => ((clienteComandaSel.id == rowData.id) ? { backgroundColor: '#a1a1a1', color: 'white', fontWeight: 'bold' } : '')
                        }}
                    />
                </PerfectScrollbar>
            </div>
        )

    }
    
    function ListaPedidoPDV(props) {
        const list = props.list || []

        return (
            <div>
                <PerfectScrollbar>
                    <DataGrid
                        id="grid_entidades"
                        columns={[
                            {
                                title: 'N° Pedido',
                                field: 'numero_pedido',
                            },
                            {
                                title: 'Identificação',
                                field: 'cliente',
                            },
                            {
                                title: 'CPF Nota',
                                field: 'cpf',
                            },
                            {
                                title: 'Status',
                                render: (rowData) => <PrintStatusPedPDV status={rowData.status}/>
                            },
                            {
                                title: 'Qtd Itens',
                                field: 'qtd'
                            },
                            {
                                title: 'Valor Total',
                                field: 'total',
                                render: (rowData) => <NumberFormat value={rowData.total || 0} decimalSeparator={","} thousandSeparator={'.'} fixedDecimalScale={true} decimalScale={2} prefix={`R$ `} style={{ color: '#373737' }} displayType="text" />
                            }
                        ]}
                        data={list}
                        onRowClick={(event, rowData) => {
                            dispatch([
                                {type: types.SET_PED_PDV, payload: rowData.numero_pedido},
                                getPedidoPdvById(rowData.numero_pedido)
                            ])
                        }}
                        options={{
                            maxBodyHeight: 1000,
                            minBodyHeight: 400,
                            rowStyle: rowData => ((pedPDVSelect == rowData.numero_pedido) ? { backgroundColor: '#a1a1a1', color: 'white', fontWeight: 'bold' } : '')
                        }}
                    />
                </PerfectScrollbar>
            </div>
        )

    }

    return (
        <Container title={`Comandas`} >
        <Loading loading={loading} />
        <Paper square elevation={2} style={{padding: '0 10px'}}>
        <DialogAlert data={dialog} handleClose={handleCloseDialog} />

        <Modal open={modals.mesa_add} modalWidth={400} modalHeight={250}>
            <Container title="Adicionar Mesa" style={{ width: 100 + '%' }} />
            <Grid container style={{ marginTop: 30 }}>
                <Grid container item spacing={2}>
                    <Grid item sm={5}>
                        <InputText
                            label="Número da Mesa"
                            value={mesa.identificacao}
                            onChange={(event) => changed({ identificacao: event.target.value })}

                        />
                    </Grid>
                    <Grid item sm={7}>
                        <InputText
                            label="Descricao"
                            value={mesa.localizacao}
                            onChange={(event) => { changed({ localizacao: event.target.value }) }} />
                    </Grid>

                </Grid>

                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 60 }}>
                    <Button color="primary" size="small" onClick={() => inserirMesa()}>
                        {<FontAwesomeIcon icon={faSave} size="2x" style={{marginBottom:10}}/>}&nbsp;Gravar Mesa
                    </Button>
                    <Button color="secondary" size="small" onClick={() => { setModals({ ...modals, mesa_add: false }) }}>
                        {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}}/>}&nbsp;Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Modal>
        
        <Modal open={modals.atrib_cli_pdv} modalWidth={400} modalHeight={400}>
            <Container title="Cliente PDV" style={{ width: 100 + '%' }} />
            <Grid container style={{ marginTop: 30 }}>
                <Grid container item spacing={2}>

                    <Grid item sm={8}>
                        <InputText
                            autofocus
                            label="Identificação do Cliente"
                            value={cliPDV}
                            onChange={(event) => dispatch([{type: types.CLI_PDV, payload: event.target.value}])}

                        />
                    </Grid>

                    <Grid item sm={4}>
                    <Button variant="outlined" style={{marginTop: 20}} onClick={() => {generateCliPDV()}}>Gerar</Button>
                    </Grid>

                    <Grid item sm={8}>
                        <InputText
                            label="CPF para a nota"
                            value={cliPDVCpf}
                            onChange={(event) => dispatch([{type: types.CLI_PDV_CPF, payload: event.target.value}])}

                        />
                    </Grid>

                </Grid>

                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 60 }}>
                    <Button color="primary" size="small" onClick={() => { setModals({ ...modals, atrib_cli_pdv: false }) }}>
                        {<FontAwesomeIcon icon={faSave} size="2x" style={{marginBottom:10}} />}&nbsp;Gravar Nome
                    </Button>
                    <Button color="secondary" size="small" onClick={() => { dispatch([{type: types.CLI_PDV, payload: ''},{type:types.CLI_PDV_CPF, payload: ''}]);setModals({ ...modals, atrib_cli_pdv: false }) }}>
                        {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}} />}&nbsp;Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Modal>

        <Modal open={modals.transferProdTo} modalWidth={400} modalHeight={250}>
            <Container title="Transferir Items" style={{ width: 100 + '%' }} />
            <Grid container style={{ marginTop: 30 }}>
                <Grid container item spacing={2}>

                    <Grid item sm={12}>
                        <InputSelect
                            label={`Lista de Clientes`}
                            value={clienteToTransferSelecionado}
                            values={[
                                { value: '', label: 'Selecione' },
                                ...listaClientes
                            ]}
                            optStyle={{padding:5}}
                            onChange={(e) => { setClienteToTransferSelecionado(e.target.value) }}
                        />
                    </Grid>

                </Grid>

                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 60 }}>
                    <Button color="primary" size="small" onClick={() => { setModals({ ...modals, transferProdTo: false }); transferirProdutos() }}>
                        {<FontAwesomeIcon icon={faSave} size="2x" style={{marginBottom: 10}} />}&nbsp;Transferir Items
                    </Button>
                    <Button color="secondary" size="small" onClick={() => { setModals({ ...modals, transferProdTo: false }) }}>
                        {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}} />}&nbsp;Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Modal>

        <Modal open={modals.cliente_add} modalWidth={650} modalHeight={250}>
            <Container title={`Abrir Comanda na mesa: ${mesaSel.identificacao}`} style={{ width: 100 + '%' }} />
            <Grid container>
                <Grid container item spacing={2}>
                    <Grid item sm={4}>
                        <InputText
                            autofocus
                            typeinput="MASK"
                            mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            label="CPF"
                            value={cliSel.cpf}
                            onChange={(event) => dispatch({ type: types.SET_PESQ_CLI, payload: { ...cliSel, cpf: event.target.value } })}
                            onBlur={() => consultaCPF()}
                        />
                    </Grid>
                    <Grid item sm={5}>
                        <InputText
                            disabled
                            label="Nome"
                            value={cliSel.nome}
                            onChange={(event) => { dispatch({ type: types.SET_PESQ_CLI, payload: { ...cliSel, nome: event.target.value } }) }} />
                    </Grid>
                </Grid>
                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 20 }}>
                    <Button color="primary" size="small" onClick={() => { inserirCliMesa(); setModals({ ...modals, cliente_add: false }) }}>
                        {<FontAwesomeIcon icon={faSave} size="2x" style={{marginBottom: 10}} />}&nbsp;Abrir Comanda
                    </Button>
                    <Button color="secondary" size="small" onClick={() => setModals({ ...modals, cliente_add: false })}>
                        {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}} />}&nbsp;Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Modal>



        <Modal open={modals.item_add} modalWidth={600} modalHeight={350}>
            <Grid container spacing={3}>
                <Container title={`Adicionar Item na mesa: ${mesaSel.identificacao}`} style={{ width: 100 + '%' }} />

                <Grid item sm={3}>
                    <InputText disabled label="Ref" value={prodSel.ref} onChange={() => { }} />
                </Grid>

                <Grid item sm={6}>

                    <InputSearch
                        label={`Nome`}
                        values={{label: prodSel.titulo}}
                        openmodal={()=>setModals({...modals, prodSearch: true})}
                        modal={modals.prodSearch}
                        modalProps={{height: 720}}
                    >
                        <Grid container spacing={3}>
                            <Container title="Cardapio" style={{ width: 100 + '%' }} />
                            <Divider />
                            <Grid sm={12}>

                                <div className={classes.content}>
                                    <Container className={classes.root}>
                                        <FilterBar
                                            pesquisar={() => carregarProds({ nome: pesqFiltro })}
                                            filter={{ label: "Nome", value: pesqFiltro.nome, setter: (e) => setPesqFiltro({ nome: e }) }}
                                            filters={[]}
                                            buttons={[
                                            ]}
                                        />
                                        <PerfectScrollbar>
                                            <DataGrid
                                                id="grid_entidades"
                                                columns={[
                                                    { title: 'Ref', field: 'ref' },
                                                    { title: 'Nome', field: 'titulo' },
                                                    { title: 'Preço', field: 'valor_atual', render: (rowData) => <NumberFormat prefix={'R$ '} value={rowData.valor_atual} decimalScale={2} displayType="text" /> },
                                                    { title: 'Estoque', field: 'quantidade_estoque' },
                                                ]}
                                                data={cardapio}
                                                onRowClick={(event, rowData) => {
                                                    setProSel({ titulo: rowData.titulo, id: rowData.id, preco: rowData.valor_atual, ref: rowData.ref })
                                                }}
                                                options={{
                                                    maxBodyHeight: 450,
                                                    minBodyHeight: 450,
                                                    rowStyle: rowData => ((prodSel.id == rowData.id) ? { backgroundColor: '#a1a1a1', color: 'white', fontWeight: 'bold' } : '')
                                                }}
                                            />
                                        </PerfectScrollbar>
                                        <Paginate
                                            rowsPerPageOptions={[5, 10, 20, 30]}
                                            rowsPerPage={prods_perpage}
                                            count={prods_total}
                                            page={(prods_page - 1)}
                                            onChangePage={(event, newPage) => handleChangePage(newPage)}
                                            onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
                                        />
                                    </Container>
                                </div>
                            </Grid>

                            <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 10 }}>
                                <Button color="primary" size="small" onClick={() => setModals({ ...modals, prodSearch: false })}>
                                    {<FontAwesomeIcon icon={faShareSquare} size="2x" style={{marginBottom: 10}} />}&nbsp;Selecionar Produto
                                </Button>
                                <Button color="secondary" size="small" onClick={() => { setModals({ ...modals, prodSearch: false }); setProSel({ titulo: '', id: 0, preco: 0, ref: '' }) }}>
                                    {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}} />}&nbsp;Cancelar
                                </Button>
                            </Grid>

                        </Grid>

                    </InputSearch>
                </Grid>

                <Grid item sm={3}>
                    <InputText disabled label="Preço" value={prodSel.preco > 0 ? `R$ ${prodSel.preco.toFixed(2)}` : ''} />
                </Grid>

                <Grid item sm={12} direction="row" justify="flex-end" alignItems="center" style={{ marginTop: 160 }}>
                    <Button color="primary" size="small" onClick={() => { inserirProduto(); setModals({ ...modals, item_add: false }) }}>
                        {<FontAwesomeIcon icon={faSave} size="2x" style={{marginBottom: 10}} />}&nbsp;Gravar Produto
                    </Button>
                    <Button color="secondary" size="small" onClick={() => { setModals({ ...modals, item_add: false }); setProSel({ titulo: '', id: 0, preco: 0, ref: '' }) }}>
                        {<FontAwesomeIcon icon={faWindowClose} size="2x" style={{marginBottom: 10}} />}&nbsp;Cancelar
                    </Button>
                </Grid>
            </Grid>
        </Modal>

        <div className={classes.root}>

                <Container title="Mesas" buttonsRight={setButtons} />


                <Grid container spacing={1}>

                    <Grid item sm={8}>
                        <Paper square elevation={3} style={{ padding: '0 10px' }}>
                            <Tabs value={tipoConsulta} indicatorColor="secondary" textColor="secondary" onChange={(e, newValue) => { setTipoConsulta(newValue); clearMesaECli(); chosenButtons(newValue) }}>
                                <Tab
                                    label="Lista de Mesas"

                                    icon={
                                        <FontAwesomeIcon icon={faAddressBook} size="3x" />
                                    }
                                    value={0}
                                    wrapped
                                />
                                <Tab
                                    label="Lista de Clientes"
                                    icon={
                                        <FontAwesomeIcon icon={faBook} size="3x" />
                                    }
                                    value={1}
                                    wrapped
                                />
                                <Tab
                                    label="PDV"
                                    icon={
                                        <FontAwesomeIcon icon={faDesktop} size="3x" />
                                    }
                                    value={2}
                                    wrapped
                                />
                                <Tab
                                    label="Pedidos PDV"
                                    icon={
                                        <FontAwesomeIcon icon={faListUl} size="3x" />
                                    }
                                    value={3}
                                    wrapped
                                />
                            </Tabs>
                            <TabPanel value={tipoConsulta} index={0}>

                                <Grid
                                    className={classes.mesas}
                                    container
                                    direction="row"
                                    justify="flex-start"
                                    alignItems="flex-start"
                                >

                                    <Mesas list={mesas} />

                                </Grid>

                            </TabPanel>
                            <TabPanel value={tipoConsulta} index={1}>
                                <ListaClientes list={listaClientes} />
                            </TabPanel>
                            <TabPanel value={tipoConsulta} index={2}>

                                <Paper square elevation={3} style={{ padding: '0 10px' }}>

                                    <PrintCatTabs 
                                        valueTabs={catPDV} 
                                        variantTabs='scrollable' 
                                        indicatorColorTabs="secondary" 
                                        textColorTabs="secondary" 
                                        onChangeTabs={setCatPDV}
                                        dados={listaCategorias}
                                        dadosCardapio={cardapio_pdv}
                                    /> 
                                </Paper>

                            </TabPanel>
                            <TabPanel value={tipoConsulta} index={3}>
                                <ListaPedidoPDV list={listaPedidospdv} />
                            </TabPanel>
                        </Paper>
                    </Grid>

                    <Grid item sm={4}>
                    <TabPanel value={tipoConsulta} index={0}>
                        <Paper square elevation={2} style={{ padding: '0 10px' }}>
                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={10}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className={classes.boldTitle}>Mesa</span>
                                        <span className={classes.totalValues} style={{ lineHeight: 5 }}>{mesaSel.identificacao}</span>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Cliente</span>
                                        <span className={classes.totalValues} style={{minWidth: 250}}>

                                            <InputSelect
                                                label={`Lista de Clientes`}
                                                value={cliente_mesa_selecionado}
                                                values={[
                                                    { value: ``, label: 'Todos' },
                                                    ...clientes
                                                ]}
                                                optStyle={{padding: 5}}
                                                onChange={(e) => { setMesaFilterItems(e.target.value) }}
                                            />

                                        </span>
                                    </div>
                                </Grid>
                            </Grid>


                            <PerfectScrollbar>
                                <DataGrid
                                    columns={[
                                        {
                                            title: 'Nome',
                                            field: 'titulo',
                                            render: rowData => <span style={{fontSize: 14}}>{rowData.titulo}</span>
                                        },
                                        {
                                            title: 'Hora do Pedido',
                                            render: rowData => moment(rowData.horario_pedido).format('DD/MM - HH:mm:ss'),
                                        },
                                        {
                                            title: 'Preço',
                                            field: 'preco',
                                            render: rowData => renderValor(rowData),
                                        },

                                    ]}
                                    data={itemsLista}
                                    options={{
                                        selection: true,
                                        selectionProps: rowData => ({ disabled: rowData.pagamento_id !== null }),
                                        maxBodyHeight: 400,
                                        minBodyHeight: 300,
                                        rowStyle: rowData => ({
                                            //backgroundColor: ((rowData.pagamento_id !== null)) ? '#4affea' : '#FFF'
                                        }),
                                    }}
                                    onSelectionChange={(rows) => { selItemToPay(rows); setItemToTransfer(rows); }}

                                />
                            </PerfectScrollbar>

                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={9}>

                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className={classes.boldTitle}>Total de Items</span>
                                        <span className={classes.totalValues}>{itemToPay.total_qtd}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor</span>
                                        <span className={classes.totalValues}>{itemToPay.valor}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Serviço</span>
                                        <span className={classes.totalValues}>{itemToPay.gorjeta}</span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>CashBack</span>
                                        <span className={classes.totalValues}>{itemToPay.cashback}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor Total</span>
                                        <span className={classes.totalValues}>{itemToPay.total_com_servico}</span>
                                    </div>

                                </Grid>

                            </Grid>

                        </Paper>
                        </TabPanel>
                    
                    <TabPanel value={tipoConsulta} index={1}>
                        <Paper square elevation={2} style={{ padding: '0 10px' }}>
                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={10}>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Cliente</span>
                                        <span className={classes.totalValues} style={{ minWidth: 250 }}>

                                            <InputSelect
                                                label={`Lista de Clientes`}
                                                value={cliente_mesa_selecionado}
                                                values={[
                                                    { value: ``, label: 'Todos' },
                                                    ...clientes
                                                ]}
                                                optStyle={{padding: 5}}
                                                onChange={(e) => { setMesaFilterItems(e.target.value) }}
                                            />

                                        </span>
                                    </div>
                                </Grid>
                            </Grid>


                            <PerfectScrollbar>
                                <DataGrid
                                    columns={[
                                        {
                                            title: 'Nome',
                                            field: 'titulo',
                                        },
                                        {
                                            title: 'Hora do Pedido',
                                            render: rowData => moment(rowData.horario_pedido).format('DD/MM/YYYY - HH:mm:ss'),
                                        },
                                        {
                                            title: 'Preço',
                                            field: 'preco',
                                            render: rowData => renderValor(rowData),
                                        },

                                    ]}
                                    data={itemsLista}
                                    options={{
                                        selection: true,
                                        selectionProps: rowData => ({ disabled: rowData.pagamento_id !== null }),
                                        maxBodyHeight: 400,
                                        minBodyHeight: 300,
                                        rowStyle: rowData => ({
                                            //backgroundColor: ((rowData.pagamento_id !== null)) ? '#4affea' : '#FFF'
                                        }),
                                    }}
                                    onSelectionChange={(rows) => { selItemToPay(rows); setItemToTransfer(rows); }}

                                />
                            </PerfectScrollbar>

                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={9}>

                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className={classes.boldTitle}>Total de Items</span>
                                        <span className={classes.totalValues}>{itemToPay.total_qtd}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor</span>
                                        <span className={classes.totalValues}>{itemToPay.valor}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Serviço</span>
                                        <span className={classes.totalValues}>{itemToPay.gorjeta}</span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>CashBack</span>
                                        <span className={classes.totalValues}>{itemToPay.cashback}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor Total</span>
                                        <span className={classes.totalValues}>{itemToPay.total_com_servico}</span>
                                    </div>

                                </Grid>

                            </Grid>

                        </Paper>
                        </TabPanel>
                    
                    {/* lista pedido pdv */}
                    <TabPanel value={tipoConsulta} index={2}>
                        <Paper square elevation={2} style={{ padding: '0 10px' }}>
                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={10}>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Cliente</span>
                                        <span className={classes.totalValues}>

                                            <InputText
                                                label="Identificação"
                                                value={cliPDV}
                                                style={{ minWidth: 250 }}
                                                //onChange={(e) => dispatch([{type: types.CLI_PDV, payload: e.target.value}])}
                                                onClick={()=>setModals({...modals, atrib_cli_pdv: true})}
                                            />

                                        </span>
                                    </div>
                                </Grid>
                            </Grid>

                            <PerfectScrollbar>
                                <DataGrid
                                    columns={[
                                        {
                                            title: 'Nome',
                                            field: 'titulo',
                                        },
                                        {
                                            title: 'Valor unitário',
                                            field: 'valor_atual',
                                            render: rowData => rowData.valor_atual.toFixed(2)
                                        },
                                        {
                                            title: 'Quantidade',
                                            field: 'qtd_pedido',
                                            render: rowData => (
                                            <span>
                                                <IconButton aria-label="reducer" style={{color: 'red'}} disabled={rowData.qtd_pedido == 0 ? true : false} onClick={()=>{reduceItemPDV(rowData)}}>
                                                    <RemoveIcon />
                                                </IconButton>
                                                    <span style={{minWidth: 25}}>{rowData.qtd_pedido}</span>
                                                <IconButton style={{color: '#4ce831'}} aria-label="adder" size="small" onClick={()=>{selItemPedidoPDV(rowData)}}>
                                                    <AddIcon />
                                                </IconButton>
                                            </span>)
                                        },
                                        {
                                            title: 'Valor Total',
                                            field: 'valor_total',
                                            render: rowData => rowData.valor_total.toFixed(2)
                                        },

                                    ]}
                                    data={pedidoPDV}
                                    options={{
                                        maxBodyHeight: 800,
                                        minBodyHeight: 300,
                                    }}

                                />
                            </PerfectScrollbar>

                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={9}>

                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className={classes.boldTitle}>Total de Items</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV.total_qtd}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV.valor}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Serviço</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV.gorjeta}</span>
                                    </div>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Cashback</span>
                                        <span className={classes.totalValues} style={{color: 'green'}}>{itemPedidoPDV.cashback}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor Total</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV.total_com_servico}</span>
                                    </div>

                                </Grid>

                            </Grid>

                        </Paper>
                        </TabPanel>
                    
                    <TabPanel value={tipoConsulta} index={3}>
                        <Paper square elevation={2} style={{ padding: '0 10px' }}>
                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={10}>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Referência</span>
                                        <span className={classes.totalValues}>

                                            <InputText
                                                readOnly={true}
                                                label="Identificação"
                                                value={pdv_pedido_selecionado.referencia}
                                                style={{ minWidth: 250 }}
                                            />

                                        </span>
                                    </div>
                                </Grid>
                            </Grid>


                            <PerfectScrollbar>
                                <DataGrid
                                    columns={[
                                        {
                                            title: 'Nome',
                                            field: 'titulo',
                                        },
                                        {
                                            title: 'Valor unitário',
                                            field: 'valor_atual',
                                            render: rowData => rowData.valor_atual.toFixed(2)
                                        },
                                        {
                                            title: 'Quantidade',
                                            field: 'qtd_pedido',
                                            render: rowData => (
                                            <span>
                                                    <span style={{minWidth: 25}}>{rowData.qtd_pedido}</span>
                                            </span>)
                                        },
                                        {
                                            title: 'Valor Total',
                                            //field: 'valor_total',
                                            render: rowData => <NumberFormat value={(rowData.valor_atual*rowData.qtd_pedido) || 0} decimalSeparator={","} thousandSeparator={'.'} fixedDecimalScale={true} decimalScale={2} prefix={`R$ `} style={{ color: '#373737' }} displayType="text" />
                                        },

                                    ]}
                                    data={pdv_pedido_selecionado.items}
                                    options={{
                                        maxBodyHeight: 800,
                                        minBodyHeight: 300,
                                    }}

                                />
                            </PerfectScrollbar>

                            <Grid container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                className={classes.blocTipyDesc}>
                                <Grid container flexDirection="row" sm={9}>

                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className={classes.boldTitle}>Total de Items</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV_selecionado.total_qtd.toFixed(2)}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV_selecionado.valor.toFixed(2)}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Serviço</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV_selecionado.gorjeta.toFixed(2)}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Cashback</span>
                                        <span className={classes.totalValues} style={{color: 'green'}}>{itemPedidoPDV_selecionado.cashback.toFixed(2)}</span>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                                        <span className={classes.boldTitle}>Valor Total</span>
                                        <span className={classes.totalValues}>{itemPedidoPDV_selecionado.total_com_servico.toFixed(2)}</span>
                                    </div>

                                </Grid>

                            </Grid>

                        </Paper>
                        </TabPanel>

                        



                    </Grid>
                </Grid>

        </div>
        </Paper>
    </Container>
    )
}

export default Comanda